<template>
  <div class="productMultiPacksSelect" @click="open()" @mouseleave="close()">
    <multiselect
      ref="multiselect"
      :value="quantityValue"
      placeholder="Wybierz opcję"
      label="title"
      :options="options"
      :show-labels="false"
      :allow-empty="false"
      :searchable="false"
      :open-direction="openUp ? 'top' : ''"
      class="productMultiPacksSelect__select multiselect--multipacks"
      @input="onInput"
    >
      <template slot="singleLabel" slot-scope="props">
        <div class="productMultiPacksSelect__option">
          <div class="productMultiPacksSelect__optionImage">
            <NewImageBox
              :alt="props.option.name"
              :src="props.option.mainPictureUrl"
              :width="60"
              :height="60"
              fit-contain-center
              image-params="w_60,h_60"
            />
          </div>
          <div class="productMultiPacksSelect__optionLeft">
            <p class="productMultiPacksSelect__optionLeftQuantity">
              {{ props.option.quantity }} {{ props.option.uom }}
            </p>
            <div
              v-if="
                typeof props.option.isCollectivePack === 'boolean' && props.option.isCollectivePack
              "
              class="productMultiPacksSelect__optionLeftPackaging"
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48" viewBox="0 0 48 48">
                <path
                  d="M6 40.9V16.3q-.7-.1-1.35-1Q4 14.4 4 13.35V7q0-1.15.9-2.075Q5.8 4 7 4h34q1.15 0 2.075.925Q44 5.85 44 7v6.35q0 1.05-.65 1.95-.65.9-1.35 1v24.6q0 1.15-.925 2.125Q40.15 44 39 44H9q-1.2 0-2.1-.975Q6 42.05 6 40.9Zm3-24.55V41h30V16.35Zm32-3V7H7v6.35Zm-23 13.5h12v-3H18ZM9 41V16.35 41Z"
                />
              </svg>
              <span>{{ props.option.isPallet ? 'Paleta' : 'Opak. zbiorcze' }}</span>
            </div>
          </div>
          <div class="productMultiPacksSelect__optionRight">
            <div class="productMultiPacksSelect__optionRightTags">
              <div
                v-if="props.option.discount"
                class="productMultiPacksSelect__optionRightTag productMultiPacksSelect__optionRightTag--discount"
              >
                {{ props.option.discount }}%
              </div>
            </div>
            <p class="productMultiPacksSelect__optionRightPrice">
              {{ props.option.unitPrice.currencyPrefix }}
              <span>
                {{
                  showNetPrices
                    ? props.option.unitPrice.netFormatted
                    : props.option.unitPrice.grossFormatted
                }}
              </span>
              {{ props.option.currencyPostfix }}/{{ props.option.uom }}
            </p>
          </div>
        </div>
      </template>
      <template slot="option" slot-scope="props">
        <div class="productMultiPacksSelect__option" @click="optionClickHandle(props.option)">
          <div class="productMultiPacksSelect__optionImage">
            <NewImageBox
              :alt="props.option.name"
              :src="props.option.mainPictureUrl"
              :width="60"
              :height="60"
              fit-contain-center
              image-params="w_60,h_60"
            />
          </div>
          <div class="productMultiPacksSelect__optionLeft">
            <p class="productMultiPacksSelect__optionLeftQuantity">
              {{ props.option.quantity }} {{ props.option.uom }}
            </p>
            <div
              v-if="
                typeof props.option.isCollectivePack === 'boolean' && props.option.isCollectivePack
              "
              class="productMultiPacksSelect__optionLeftPackaging"
            >
              <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48" viewBox="0 0 48 48">
                <path
                  d="M6 40.9V16.3q-.7-.1-1.35-1Q4 14.4 4 13.35V7q0-1.15.9-2.075Q5.8 4 7 4h34q1.15 0 2.075.925Q44 5.85 44 7v6.35q0 1.05-.65 1.95-.65.9-1.35 1v24.6q0 1.15-.925 2.125Q40.15 44 39 44H9q-1.2 0-2.1-.975Q6 42.05 6 40.9Zm3-24.55V41h30V16.35Zm32-3V7H7v6.35Zm-23 13.5h12v-3H18ZM9 41V16.35 41Z"
                />
              </svg>
              <span>{{ props.option.isPallet ? 'Paleta' : 'Opak. zbiorcze' }}</span>
            </div>
          </div>
          <div class="productMultiPacksSelect__optionRight">
            <div class="productMultiPacksSelect__optionRightTags">
              <div
                v-if="props.option.discount"
                class="productMultiPacksSelect__optionRightTag productMultiPacksSelect__optionRightTag--discount"
              >
                {{ props.option.discount }}%
              </div>
            </div>
            <p class="productMultiPacksSelect__optionRightPrice">
              {{ props.option.unitPrice.currencyPrefix }}
              <span>
                {{
                  showNetPrices
                    ? props.option.unitPrice.netFormatted
                    : props.option.unitPrice.grossFormatted
                }}
              </span>
              {{ props.option.currencyPostfix }}/{{ props.option.uom }}
            </p>
          </div>
        </div>
      </template>
      <template slot="noResult"> Brak wyników wyszukiwania.</template>
      <template slot="noOptions"> Lista opcji jest pusta.</template>
    </multiselect>
    <div class="productMultiPacksSelect__label">Wybierz wielopak</div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
import NewImageBox from '@/components/NewImageBox.vue';

export default {
  name: 'ProductMultiPacksSelect',
  components: { NewImageBox, Multiselect },
  props: {
    product: {
      type: Object,
      default: () => {},
      required: true,
    },
    options: {
      type: Array,
      default: () => [],
      required: true,
    },
    openUp: {
      type: Boolean,
      default: undefined,
    },
    refreshTile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('auth', ['showNetPrices']),
    quantityValue() {
      return this.options.find(option => option.slug === this.product.slug);
    },
  },
  methods: {
    gTagProductClick(item) {
      const categories = this.product.category.namesInPath.reduce((acc, curr, index) => {
        acc['category' + (index === 0 ? '' : index + 1)] = curr;
        return acc;
      }, {});
      this.$gtm.push({ ecommerce: null });
      this.$gtm.push({
        event: 'select_item',
        ecommerce: {
          item_list_id: '',
          item_list_name: '',
          items: [
            {
              item_id: item.id,
              item_name: item.name,
              discount: item.discount ? item.discount : 0,
              brand: this.product.brand ? this.product.brand.name : '',
              ...categories,
              item_list_id: '',
              item_list_name: '',
              promotion_id: item?.promotion?.id ?? '',
              promotion_name: item?.promotion?.name ?? '',
              price: item.gross,
              variant: '',
              quantity: 1,
            },
          ],
        },
      });
    },
    optionClickHandle(product) {
      if (this.refreshTile) {
        this.$emit('refresh', product);
      } else {
        this.gTagProductClick(product);
        this.$router.push(
          this.localePath({ name: 'product-slug', params: { slug: product.slug } }),
        );
      }
    },
    open() {
      if (this.$refs.multiselect) {
        this.$refs.multiselect.activate();
      }
    },
    close() {
      if (this.$refs.multiselect) {
        this.$refs.multiselect.deactivate();
      }
    },
    onInput(optionObject) {
      if (typeof optionObject.quantity !== 'undefined') {
        this.quantity = optionObject.quantity;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.productMultiPacksSelect {
  $root: &;
  position: relative;
  top: 0.4rem;

  &__select {
    &.multiselect--active {
      ~ #{$root}__label {
        opacity: 0;
      }
    }
  }

  &__label {
    position: absolute;
    left: 5.4rem;
    top: -0.4rem;
    padding: 0 0.5rem;
    background: white;
    font-size: 14px;
    line-height: 1;
    z-index: 99;
    display: none;
    transition: opacity $tr;
  }

  &__option {
    display: flex;
    flex: 1;
    align-items: center;
    font-size: 1.4rem;
    height: 100%;
    color: $cMainNeutral;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(to right, $cBg, $cWhite);
      opacity: 0;
      z-index: -1;
      transition: opacity $tr;
    }

    &:hover {
      &::after {
        opacity: 1;
      }

      #{$root}__optionLeft {
        text-shadow: 0 0 1px $cMainDark;
      }
    }
  }

  &__optionImage {
    padding: 0.5rem;
    border-right: 1px solid $cAddLight;
    height: 4.6rem;
    width: 4.6rem;
    margin-right: 0.7rem;
  }

  &__optionLeft {
    transition: text-shadow $tr;
  }

  &__optionLeftQuantity {
    font-weight: 700;
  }

  &__optionLeftPackaging {
    display: flex;
    align-items: center;

    svg {
      width: 1.2rem;
      height: auto;

      path {
        fill: $cAddDark02;
      }
    }

    span {
      padding-left: 0.2rem;
      font-size: 1rem;
      color: $cAddDark02;
    }
  }

  &__optionRight {
    display: flex;
    column-gap: 0.5rem;
    align-items: center;
    margin-left: auto;
    padding-right: 1rem;
  }

  &__optionRightPrice {
    font-family: $fSecond;

    span {
      font-weight: 500;
    }
  }

  &__optionRightTags {
    display: flex;
    column-gap: 0.5rem;
  }

  &__optionRightTag {
    padding: 0.1rem 0.4rem;
    font-size: 1.2rem;
    font-weight: 800;
    border-radius: 0.2rem;
    color: $cWhite;

    &--discount {
      background-color: $cBadgeProm;
    }

    &--eko {
      background-color: $cBadgeBest;
    }
  }
}
</style>
